export default __webpack_public_path__ + "img/fGlwDuGz.3dca4c0f.svg";